import { atom } from 'recoil';
import { TInterviewFirmInfo } from 'modules/community';

export const interviewFirmInfoState = atom<TInterviewFirmInfo>({
  key: 'interviewFirmInfoState',
  default: {
    isConsultingFirm: false,
    interviewResult: '',
    employmentType: '',
  },
});

//후기 등록 완료 모달
export const completeModalVisibleState = atom({
  key: 'completeModalVisibleState',
  default: false,
});
